// Mock data for the autobiography generator

export const mockQuestions = [
  // Childhood & Early Memories (1-7)
  {
    id: 1,
    category: "Childhood & Early Memories",
    section: 1,
    question: "Where were you born, and what do you know about the day you came into the world?",
    placeholder: "e.g., I was born on a cold winter morning in Manchester. My mother always told me that..."
  },
  {
    id: 2,
    category: "Childhood & Early Memories",
    section: 1,
    question: "What was your childhood home like? Describe the sights, sounds, and atmosphere.",
    placeholder: "e.g., Our home was a small cottage with creaky wooden floors. I remember the smell of..."
  },
  {
    id: 3,
    category: "Childhood & Early Memories",
    section: 1,
    question: "Who were the most important people in your early life, and what made them special to you?",
    placeholder: "e.g., My grandmother lived with us and she was my closest confidant. She would..."
  },
  {
    id: 4,
    category: "Childhood & Early Memories",
    section: 1,
    question: "What is one of your earliest childhood memories that still stands out clearly today?",
    placeholder: "e.g., I must have been about four years old when I first learned to ride a bicycle..."
  },
  {
    id: 5,
    category: "Childhood & Early Memories",
    section: 1,
    question: "What did a typical day look like for you when you were a child?",
    placeholder: "e.g., I'd wake up to the sound of birds and the smell of breakfast cooking..."
  },
  {
    id: 6,
    category: "Childhood & Early Memories",
    section: 1,
    question: "What games, hobbies, or activities did you love most growing up?",
    placeholder: "e.g., I spent hours building forts in the backyard with my siblings..."
  },
  {
    id: 7,
    category: "Childhood & Early Memories",
    section: 1,
    question: "Was there a moment in childhood that taught you an important lesson about life?",
    placeholder: "e.g., When I was eight, I learned the hard way that honesty is always the best policy..."
  },
  
  // Teenage Years (8-12)
  {
    id: 8,
    category: "Teenage Years",
    section: 2,
    question: "What kind of teenager were you, and how did others describe you at the time?",
    placeholder: "e.g., I was shy and studious. My friends called me the responsible one..."
  },
  {
    id: 9,
    category: "Teenage Years",
    section: 2,
    question: "What was school like for you, and were there any teachers who made a lasting impact?",
    placeholder: "e.g., Mr. Thompson, my English teacher, was the first person who told me I could write..."
  },
  {
    id: 10,
    category: "Teenage Years",
    section: 2,
    question: "Who were your closest friends during your teenage years, and what adventures did you share together?",
    placeholder: "e.g., Sarah and I were inseparable. We'd spend entire summers exploring the countryside..."
  },
  {
    id: 11,
    category: "Teenage Years",
    section: 2,
    question: "Do you remember your first job or the first time you earned your own money? What was that experience like?",
    placeholder: "e.g., I worked at the corner shop on weekends. That first paycheck felt like..."
  },
  {
    id: 12,
    category: "Teenage Years",
    section: 2,
    question: "What music, culture, or trends shaped your teenage years?",
    placeholder: "e.g., The Beatles changed everything for my generation. I remember when..."
  },
  
  // Early Adulthood (13-16)
  {
    id: 13,
    category: "Early Adulthood",
    section: 3,
    question: "When did you first feel like you were stepping into adulthood, and what caused that moment?",
    placeholder: "e.g., Moving away to university was when I truly felt grown up..."
  },
  {
    id: 14,
    category: "Early Adulthood",
    section: 3,
    question: "What were your biggest hopes or dreams when you were younger?",
    placeholder: "e.g., I dreamed of traveling the world and writing novels..."
  },
  {
    id: 15,
    category: "Early Adulthood",
    section: 3,
    question: "What was your first serious job or career step, and how did it shape your path?",
    placeholder: "e.g., My first teaching position opened doors I never expected..."
  },
  {
    id: 16,
    category: "Early Adulthood",
    section: 3,
    question: "Tell us about the first place you lived on your own or away from home.",
    placeholder: "e.g., A tiny flat in the city with barely any furniture, but it was mine..."
  },
  
  // Relationships & Family (17-20)
  {
    id: 17,
    category: "Relationships & Family",
    section: 4,
    question: "How did you meet the most important people in your life, such as your partner or closest companions?",
    placeholder: "e.g., I met my husband at a friend's wedding. He asked me to dance and..."
  },
  {
    id: 18,
    category: "Relationships & Family",
    section: 4,
    question: "What moments in your relationships have meant the most to you?",
    placeholder: "e.g., When my partner stood by me during the hardest time of my life..."
  },
  {
    id: 19,
    category: "Relationships & Family",
    section: 4,
    question: "If you have children, what was it like becoming a parent for the first time?",
    placeholder: "e.g., Holding my daughter for the first time, I felt a love I didn't know existed..."
  },
  {
    id: 20,
    category: "Relationships & Family",
    section: 4,
    question: "What family traditions or memories bring you the most joy when you think back?",
    placeholder: "e.g., Every Christmas Eve, we'd gather around the piano and sing together..."
  },
  
  // Turning Points (21-23)
  {
    id: 21,
    category: "Turning Points",
    section: 5,
    question: "What moment in your life changed everything or set you on a completely new path?",
    placeholder: "e.g., When I lost my job, I thought my world was ending, but it led me to..."
  },
  {
    id: 22,
    category: "Turning Points",
    section: 5,
    question: "What has been the greatest challenge you have ever faced, and how did you overcome it?",
    placeholder: "e.g., Fighting through illness taught me strength I never knew I had..."
  },
  {
    id: 23,
    category: "Turning Points",
    section: 5,
    question: "Looking back, was there a risk you took that ended up shaping your life in an important way?",
    placeholder: "e.g., Leaving my stable job to pursue my passion was terrifying, but..."
  },
  
  // Achievements & Life Lessons (24-26)
  {
    id: 24,
    category: "Achievements & Life Lessons",
    section: 6,
    question: "What achievement or moment in your life makes you feel most proud?",
    placeholder: "e.g., Watching my children graduate and knowing they'd become good people..."
  },
  {
    id: 25,
    category: "Achievements & Life Lessons",
    section: 6,
    question: "What personal qualities helped you get through difficult times?",
    placeholder: "e.g., My stubbornness, which my mother called determination, kept me going when..."
  },
  {
    id: 26,
    category: "Achievements & Life Lessons",
    section: 6,
    question: "What mistakes or setbacks ended up teaching you the most about life?",
    placeholder: "e.g., My failed business venture taught me more about resilience than any success..."
  },
  
  // Reflection (27-30)
  {
    id: 27,
    category: "Reflection",
    section: 7,
    question: "How has the world changed during your lifetime, and what changes stand out the most to you?",
    placeholder: "e.g., I've watched us go from rotary phones to smartphones in everyone's pocket..."
  },
  {
    id: 28,
    category: "Reflection",
    section: 7,
    question: "What moments in life have brought you the greatest happiness?",
    placeholder: "e.g., Simple Sunday mornings with my family, no grand events, just togetherness..."
  },
  {
    id: 29,
    category: "Reflection",
    section: 7,
    question: "What advice would you give to your younger self if you could go back in time?",
    placeholder: "e.g., Don't be so afraid of making mistakes. They're how you grow..."
  },
  {
    id: 30,
    category: "Reflection",
    section: 7,
    question: "If future generations of your family could remember just one thing about you, what would you want it to be?",
    placeholder: "e.g., That I loved deeply, lived authentically, and always tried to leave things better than I found them..."
  }
];

export const mockAutobiography = {
  title: "The Life of Sarah Thompson",
  subtitle: "A Personal Memoir",
  content: `# The Life of Sarah Thompson
## A Personal Memoir

### Chapter 1: Early Years

I grew up in a small town nestled between rolling hills, where everyone seemed to know each other's names and stories. My earliest memories are painted in the golden hues of summer afternoons—the sound of children's laughter echoing through the streets, the smell of fresh bread from the local bakery, and the warmth of my grandmother's embrace.

Those formative years in that close-knit community shaped my understanding of what it means to belong. Every neighbor was an extended family member, every street corner held a memory, and every sunset promised another day of simple joys.

My father, a craftsman with weathered hands and a gentle spirit, taught me that true wealth isn't measured in possessions but in the quality of work you leave behind. I would watch him in his workshop, transforming raw wood into beautiful furniture, each piece a testament to patience and skill.

### Chapter 2: The Journey Begins

School opened new worlds to me. I discovered that books could transport you anywhere, that mathematics held hidden patterns of beauty, and that friendships forged in childhood could last a lifetime. Mrs. Henderson, my fifth-grade teacher, saw something in me that I hadn't yet recognized—a curiosity that couldn't be contained within textbook pages.

It was during those school years that I first dreamed of possibilities beyond my small town. Not because I wanted to escape, but because I realized the world was vast and full of stories waiting to be discovered and told.

### Chapter 3: Finding My Path

My career began humbly, as most worthwhile journeys do. I started as an apprentice, learning the fundamentals of my craft from mentors who generously shared their knowledge. Each day brought new challenges, small failures, and incremental victories that built my confidence piece by piece.

The turning point came when I realized that success wasn't about reaching a destination but about the person you become along the way. Every project, every collaboration, every setback taught me something invaluable about resilience, creativity, and the power of perseverance.

### Chapter 4: Love and Connection

Relationships have been the true treasures of my life. I learned that love comes in many forms—the steadfast support of family, the joy of deep friendships, the romance that makes your heart skip a beat, and the unconditional love you give and receive.

Meeting my life partner felt like finding a missing piece I didn't know I was searching for. Together, we built not just a life, but a partnership based on mutual respect, shared dreams, and the understanding that growing together means giving each other room to grow individually.

### Chapter 5: Weathering Storms

No life story is complete without its chapters of difficulty. I faced my share of challenges—professional setbacks, personal losses, moments when the path ahead seemed impossibly dark. But it was during these difficult times that I discovered my true strength.

I learned that resilience isn't about never falling; it's about always getting back up. That vulnerability isn't weakness; it's the courage to be authentic. That asking for help isn't failure; it's wisdom.

### Chapter 6: The Harvest Years

Looking back now, I see how every experience—joyful or painful—was necessary. The struggles taught me compassion, the successes taught me humility, and the journey taught me gratitude.

My greatest achievement isn't any single accomplishment, but rather the life I've built—filled with meaningful work, genuine relationships, and the knowledge that I've tried to leave the world a little better than I found it.

### Chapter 7: Reflections and Legacy

If my story can teach anything, it's this: your life doesn't have to be extraordinary to be meaningful. The small moments of kindness, the honest work, the love you share, the challenges you overcome—these are what create a life worth remembering.

I hope that those who read this will understand that every person's story matters. Your experiences, your lessons, your journey—they all contribute to the tapestry of human experience. Don't wait to share your story. Don't think it's not important enough. Your life, in all its ordinary extraordinariness, is a gift.

---

*This memoir was created to preserve memories, honor experiences, and pass wisdom to future generations.*`,
  wordCount: 3450,
  chapters: 7,
  generatedDate: new Date().toISOString()
};

export const mockTestimonials = [
  {
    id: 1,
    name: "Margaret Williams",
    age: 72,
    text: "I never thought I could write a book, but this made it so easy. My grandchildren will have my story forever.",
    rating: 5
  },
  {
    id: 2,
    name: "John Davies",
    age: 68,
    text: "What a beautiful gift for my 70th birthday. The AI captured my voice perfectly!",
    rating: 5
  },
  {
    id: 3,
    name: "Patricia Chen",
    age: 65,
    text: "I created one for my mother who is 92. She cried tears of joy reading her life story in such beautiful words.",
    rating: 5
  }
];

export const mockFAQs = [
  {
    question: "How long does it take?",
    answer: "Most people complete the questions in about 10 minutes. Your autobiography is generated in under a minute."
  },
  {
    question: "Do I need to be a good writer?",
    answer: "Not at all. Simply answer the questions and our AI will turn your memories into a well-written memoir."
  },
  {
    question: "How long is the autobiography?",
    answer: "Your memoir is typically between 3,000 and 6,000 words, depending on your responses."
  },
  {
    question: "Can I edit my story?",
    answer: "Yes. After generation you can copy and edit your autobiography however you like."
  },
  {
    question: "Can I share it with family?",
    answer: "Yes. You can download your autobiography and share it with friends or family."
  },
  {
    question: "What about hardcover books?",
    answer: "You can order professionally printed hardcover books delivered to your door. Perfect for gifting to family members!"
  }
];
